module.exports = __webpack_public_path__ + "img/calendar.b5a6b8aa.svg";